<template>
	<div class="content animated fadeIn">
		<div class="top">
			<div class="user-info"
				@click="toPersonCenter">
				<div class="photoBox">
					<img v-if="!imgError"
						:src="`${avatarUrl}/facePhoto/getFacePhotoById?memberId=${memberInfo.memberIdAesEncrypt}`"
						alt=""
						@error="handleError">
					<img v-else
						:src="errorImg"
						alt="">
				</div>
				<div class="info-detail">
					<div class="name">
						{{userInfo.memberNickname}}
						{{userInfo.memberId}}
						<van-icon name="arrow" />
					</div>
					<div class="dept">
						<span v-show="userInfo.memberOtherDepartment"
							class="first">{{userInfo.memberOtherDepartment}}</span>
						<span class="sec">{{role=='student'?'学生':'职工'}}</span>
					</div>
				</div>
			</div>

			<img class="set"
				src="../assets/images/setting.png"
				alt=""
				@click="$router.push('/set')">
			<img class="my-bg"
				src="../assets/images/my-bg.png"
				alt="">
		</div>
		<div class="mainBox">
			<!-- 代办和邮箱 -->
			<div v-if="role=='teacher'"
				class="first-squ">
				<div class="left"
					@click="toOA">
					<div class="row1">
						<img src="../assets/images/daiban.png"
							alt="">
						我的代办
					</div>
					<div class="row2">
						{{OACount}}条
					</div>
				</div>
				<div class="devider"></div>
				<div class="right"
					@click="toEmail('/app/mailbox/qqEmailLogin')">
					<div class="row1">
						<img src="../assets/images/youxiang.png"
							alt="">
						我的邮箱
					</div>
					<div class="row2">
						{{emailCount}}封
					</div>
				</div>
			</div>
			<!--  图书借阅和本月消费-->
			<div v-else
				class="first-squ">
				<div class="left"
					@click="toWyy('/tlzy/tsjy.html')">
					<div class="row1">
						<img src="../assets/images/tushu.png"
							alt="">
						图书借阅
					</div>
					<div class="row2">
						{{bookNum}}本
					</div>
				</div>
				<div class="devider"></div>
				<div class="right"
					@click="toWyy('/tlzy/yktcx.html')">
					<div class="row1">
						<img src="../assets/images/xiaofei.png"
							alt="">
						本月消费
					</div>
					<div class="row2">
						{{expense}}元
					</div>
				</div>
			</div>
			<!-- 我的收藏 -->
			<div class="my-collection">
				<div class="title-row">
					<span class="title">我的收藏</span>
					<span class="more"
						@click="toMyApps('我的收藏')">
						更多
						<van-icon name="arrow" />
					</span>
				</div>
				<p v-if="collectionList.length == 0"
					style="text-align: center;font-size: .32rem;margin-top:.46rem;color:#999">暂无收藏</p>
				<ul class="app-list">
					<li v-for="(item,index) in collectionList"
						:key="item.appId"
						@click="operationWyy(item.appId,item.appUrl)"
						class="app-list-item">
						<div class="img">
							<img class="app-logo"
								:src="item.appImages"
								alt="">
							<img v-if="item.appIntranet==1"
								src="../assets/images/nei_icon.png"
								class="school"
								alt="">
						</div>
						<div class="app-name">{{item.appName}}</div>
					</li>
				</ul>
			</div>
			<!-- 我的成果 -->
			<div class="my-cg"
				v-if="role!='student'">
				<div class="title-row">
					<span class="title">我的成果</span>
					<span class="more"
						@click="toMyApps('我的成果')">
						更多
						<van-icon name="arrow" />
					</span>
				</div>
				<ul class="app-list">
					<li v-for="(item,index) in memberAppList_wdcg"
						:key="item.appId"
						class="app-list-item"
						@click="operationWyy(item.appId,item.appUrl)">
						<div class="img">
							<img class="app-logo"
								:src="item.appImages"
								alt="">
							<img v-if="item.appIntranet==1"
								src="../assets/images/nei_icon.png"
								class="school"
								alt="">
						</div>
						<div class="app-name">{{item.appName}}</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";
import { Toast } from "vant";
export default {
  computed: {
    ...mapState(["memberInfo", "roleList"]),
  },
  data() {
    return {
      memberAppList_wdcg: [],
      memberAppList_grxx: [],
      collectionList: [],
      userInfo: "",
      userImage: "",
      errorImg: "",
      imgError: false,
      role: "",
      // 学生图书借阅本数
      bookNum: 0,
      // 学生本月消费
      expense: 0,
      // 教师邮箱数量
      emailCount: 0,
      // 教师oa代办数量
      OACount: 0,
      avatarUrl: "",
    };
  },
  mounted() {
    if (this.roleList.indexOf("student") == -1) {
      this.role = "teacher";
      this.getEmailCount();
      this.getOACount();
    } else {
      this.role = "student";
      this.getBookLending();
      this.getThisMonthExpense();
    }
    if (this.memberInfo.memberSex == 1) {
      this.errorImg = require("../assets/images/man.png");
    } else if (this.memberInfo.memberSex == 2) {
      this.errorImg = require("../assets/images/woman.png");
    } else {
      this.errorImg = require("../assets/images/man.png");
    }
    this.getMemberByUsername();
    this.getMemberApp("wd_wdcg");
    this.getMemberApp("wd_wdxx");
    this.findCollectionAppList();
    // this.getAvata()
    this.avatarUrl = avatarUrl;
  },
  methods: {
    // 跳转到我的应用页面
    toMyApps(val) {
      let title = val,
        list = [];
      switch (val) {
        case "我的成果":
          list = this.memberAppList_wdcg;
          break;
        case "我的收藏":
          list = this.collectionList;
          break;
        default:
          break;
      }
      this.$router.push({
        path: "/my-apps",
        query: {
          title,
          list,
        },
      });
    },
    // 跳转个人中心
    toPersonCenter() {
      this.$router.push("/person-center");
    },
    // 教师oa代办跳转
    toOA() {
      let url=oaUrl+ `/hnrdapp/platforms/h5/assets/www/mobilemain.action?method=mabileBlzxServiceIndex&type=DB&fromportal=yes`
      location.href = url;
    },
    //教师邮箱跳转
    toEmail(val) {
      location.href = emailUrl + val;
    },
    //跳转微应用页面 学生图书借阅，本月消费
    toWyy(val) {
      location.href = wyyUrl + val;
    },

    // 发送请求获取oa代办数量
    getOACount() {
      this.$axios({
        url: emailUrl + "/app/oa/workFolwDb?type=db",
        method: "POST",
      }).then(
        (res) => {
          if (res.result == "success") {
            this.OACount = res.count;
          }
        },
        (error) => {}
      );
    },
    // 发送请求获取我的邮箱数量
    getEmailCount() {
      this.$axios({
        url: emailUrl + `/app/mailbox/count`,
        method: "POST",
      }).then(
        (res) => {
          if (res.success) {
            this.emailCount = res.count;
          }
        },
        (error) => {}
      );
    },
    // 发送请求获取本月消费
    getThisMonthExpense() {
      this.$axios({
        url:
          wyyUrl +
          `/api/v1/index/getConsumeThisMonth?username=${this.memberInfo.memberIdAesEncrypt}`,
        method: "POST",
      }).then(
        (res) => {
          if (res.success) {
            this.expense = res.obj;
          }
        },
        (error) => {}
      );
    },
    // 发送请求获取图书借阅和本月消费
    getBookLending() {
      this.$axios({
        // 用户名开发过程用写死的userName
        url:
          wyyUrl +
          `/api/book/findBookList?type=0&userName=${this.memberInfo.memberIdAesEncrypt}`,
        method: "POST",
      }).then(
        (res) => {
          if (res.success) {
            this.bookNum = res.count;
          }
        },
        (error) => {}
      );
    },
    handleError() {
      this.imgError = true;
    },
    // 跳转微应用
    operationWyy(id, url) {
      this.$common.appAccessStatistical(id);
      if (url == "http://" || url == "https://") {
        Toast("系统建设中，敬请期待！");
      } else {
        location.href = url;
      }
    },
    // 获取用户信息
    getMemberByUsername() {
      this.$axios({
        url: baseUrl + "/app/casMember/getMemberByUsername",
        method: "POST",
      }).then(
        (res) => {
          if (res.success) {
            this.userImage =
              authenticationUrl +
              "/public/getImg?path=" +
              encodeURIComponent(res.attributes.modules.memberImage);
            this.userInfo = res.attributes.modules;
          }
        },
        (error) => {}
      );
    },
    getMemberApp(type) {
      this.$axios({
        method: "post",
        url: baseUrl + "/app/memberApp/getMemberApp",
        data: this.qs.stringify({
          roleList: JSON.stringify(this.roleList),
        }),
      })
        .then(async (res) => {
          if (res.success) {
            let appList;
            res.obj.forEach(function (item, index) {
              if (item.modulesCode == type) {
                appList = [item];
              }
            });
            if (type == "wd_wdcg") {
              this.memberAppList_wdcg = await this.$common.setMemberAppData(
                appList,
                type
              );
              this.memberAppList_wdcg = this.memberAppList_wdcg.slice(0, 4);
            } else {
              this.memberAppList_grxx = await this.$common.setMemberAppData(
                appList,
                type
              );
            }
          }
        })
        .catch((error) => {});
    },
    //查询收藏的应用
    findCollectionAppList() {
      this.$axios({
        url: baseUrl + "/app/collectionApp/findCollectionAppList",
        method: "POST",
      }).then(
        (res) => {
          if (res.success) {
            this.setCollectData(res);
          }
        },
        (error) => {}
      );
    },
    setCollectData(res) {
      for (let i = 0; i < res.obj.length; i++) {
        if (
          res.obj[i].appUrl != null &&
          res.obj[i].appUrl != "" &&
          this.memberInfo != ""
        ) {
          res.obj[i].appUrl = res.obj[i].appUrl.replace(
            "{memberid}",
            this.memberInfo.memberUsername
          );
          if (res.obj[i].appUrl.indexOf("{memberAesEncrypt}") > -1) {
            res.obj[i].appUrl = res.obj[i].appUrl.replace(
              "{memberAesEncrypt}",
              this.$common.getSecretKey(res.obj[i].appId)
            );
          }
          res.obj[i].appUrl = res.obj[i].appUrl.replace(
            "{quicklyTicket}",
            this.memberInfo.quicklyTicket
          );
        }
        if (res.obj[i].portalAppIcon != null) {
          res.obj[i].appImages =
            baseUrl +
            "/public/getImg?path=" +
            encodeURI(res.obj[i].portalAppIcon.templetAppImage);
        } else {
          res.obj[i].appImages =
            baseUrl + "/public/getImg?path=" + encodeURI(res.obj[i].appImages);
        }
      }
      this.collectionList = res.obj.slice(0, 4);
    },
  },
};
</script>

<style scoped lang="less">
.content {
  width: 100%;
  max-height: 100vh;
  box-sizing: border-box;
  overflow-y: auto;
  padding-bottom: 1.2rem;
  background: #fafbff;
}
.content::-webkit-scrollbar {
  display: none !important;
  width: 0px;
  height: 0px;
}
.top {
  width: 100%;
  height: 5.02rem;
  box-sizing: border-box;
  position: relative;
}
.top .user-info {
  display: flex;
  position: absolute;
  top: 1.13rem;
  left: 0.39rem;
  height: 1.53rem;
  .photoBox {
    margin-right: 0.43rem;
    width: 1.53rem;
    height: 1.53rem;
    border-radius: 50%;
    img {
      width: 1.53rem;
      height: 1.53rem;
      border-radius: 50%;
    }
  }
  .info-detail {
    .name {
      height: 0.45rem;
      display: flex;
      align-items: center;
      font-size: 0.48rem;
      font-family: PingFang SC;
      font-weight: 500;
      color: #ffffff;
      margin-top: 0.18rem;
      .van-icon {
        font-size: 0.3rem;
        color: rgba(255, 255, 255, 0.6);
        margin-left: 0.45rem;
      }
    }
    .dept {
      display: flex;
      margin-top: 0.26rem;
      span {
        display: inline-block;
        height: 0.44rem;
        line-height: 0.44rem;
        font-size: 0.24rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: #ffffff;
        background: rgba(255, 255, 255, 0.25);
        border-radius: 0.22rem;
      }
      span.first {
        padding: 0 0.14rem;
        margin-right: 0.15rem;
      }
      span.sec {
        padding: 0 0.16rem;
      }
    }
  }
}
.mainBox {
  width: 100%;
  // max-height: calc(100vh - 4.42rem);
  // overflow-y: auto;
  margin-top: -1.8rem;
  padding: 0 0.23rem;
  box-sizing: border-box;
  padding-bottom:.2rem;
  // position: absolute;
  .first-squ {
    height: 1.8rem;
    background: #ffffff;
    border-radius: 0.2rem;
    display: flex;
    justify-content: center;
    padding-top: 0.41rem;
    .left,
    .right {
      width: 46%;
      font-size: 0.26rem;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #999999;
      text-align: center;
      .row1 {
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 0.46rem;
          height: 0.46rem;
          margin-right: 0.19rem;
        }
      }
      .row2 {
        margin-top: 0.2rem;
        font-size: 0.34rem;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #555555;
      }
    }
    .devider {
      width: 0;
      height: 0.6rem;
      border-right: 0.02rem solid #e8ebec;
      margin-top: 0.19rem;
    }
  }
  .my-collection,
  .my-cg {
    width: 100%;
    min-height: 2.64rem;
    background: #ffffff;
    border-radius: 0.2rem;
    margin-top: 0.25rem;
    padding: 0.35rem;
    box-sizing: border-box;
    .title-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 0.32rem;
      font-size: 0.32rem;
      font-family: PingFang SC;
      font-weight: 500;
      color: #282828;
      .more {
        font-size: 0.22rem;
        font-family: PingFang SC;
        font-weight: 400;
        color: #a7a7a7;
        display: flex;
        align-items: center;
        .van-icon {
          margin-left: 0.1rem;
        }
      }
    }
    .app-list {
      margin-top: 0.43rem;
      display: flex;
      font-size: 0.26rem;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #555555;
      .app-list-item {
        width: 25%;
        display: flex;
        flex-direction: column;
        overflow-x: hidden;
        padding: 0 0.15rem;
        box-sizing: border-box;
        align-items: center;
        .img {
          position: relative;
          .app-logo {
            width: 0.765rem;
            height: 0.76rem;
          }
          .school {
            width: 0.3rem;
            height: 0.3rem;
            position: absolute;
            top: 0;
            right: -0.12rem;
          }
          margin-bottom: 0.14rem;
        }
        .app-name {
          width: 100%;
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3; // 控制多行的行数
          -webkit-box-orient: vertical;
        }
      }
    }
  }
}

.top .my-bg {
  position: absolute;
  width: 100%;
  height: 5.02rem;
  top: 0;
  left: 0;
  z-index: -1;
}
.top .set {
  width: 0.44rem;
  height: 0.44rem;
  position: absolute;
  top: 0.89rem;
  right: 0.28rem;
}
</style>
